document.addEventListener('DOMContentLoaded', (event) => {
  const swiperEl = document.querySelector('.banner__box_slide');
  if (!swiperEl) return; // Exit if element doesn't exist

  var swiper = new Swiper('.banner__box_slide', {
    spaceBetween: 30,
    centeredSlides: true,
    autoHeight: true,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
});
